import React from "react";
import Layout from "@hoc/layouts/Layout";
import GroupOfSpeciesGFCMIndex from "@components/GroupOfSpeciesGFCM/GroupOfSpeciesGFCMIndex";

const GroupOfSpeciesGFCMPage = () => {
  return (
    <Layout>
      <GroupOfSpeciesGFCMIndex />
    </Layout>
  );
};

export default GroupOfSpeciesGFCMPage;
